import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Dropzone from 'react-dropzone';
import { autobind } from 'core-decorators';
import uuid from 'uuid/v4';

import { uploadChargerImage } from 'services/api';

import Modal, { ModalBody, ModalFooter } from 'AppComponents/Modal';

import './styles.scss';


class Upload extends Component {

  static propTypes = {
    charger: PropTypes.shape({ pk: PropTypes.number }).isRequired,
    display: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    onNewImageSuccess: PropTypes.func.isRequired,
  };

  static defaultProps = {
    display: false,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      files: [],
      filesById: {},
      uploaded: [],
      uploading: [],
      errored: [],
      selected: [],
      progress: 0,
    };
  }

  @autobind
  onDrop(files) {
    const filesById = {};
    const fileIds = files.map((file) => {
      const id = uuid();
      filesById[id] = file;
      return id;
    });
    this.setState({
      files: [...this.state.files, ...fileIds],
      filesById: Object.assign({}, this.state.filesById || null, filesById),
    });
  }

  handleImageClick(id) {
    if (this.state.uploaded.indexOf(id) === -1) {
      const selected = [...this.state.selected];
      const indexOf = this.state.selected.indexOf(id);
      if (indexOf === -1) selected.push(id);
      else selected.splice(indexOf, 1);
      this.setState({ selected });
    }
  }

  @autobind
  handleSubmit() {
    if (this.state.selected.length > 0) {
      this.uploadImages(this.state.selected);
    } else {
      this.uploadImages(this.state.files);
    }
  }

  uploadImages(images) {
    this.setState({
      isSubmitting: true,
      uploading: images,
      progress: 0,
    }, () => {
      images.forEach((id) => {
        const file = this.state.filesById[id];
        if (this.state.uploaded.indexOf(id) === -1) {
          uploadChargerImage(
            this.props.charger.pk,
            { name: file.name },
            file,
          ).then(({ response, error }) => {
            const errored = [...this.state.errored];
            const uploaded = [...this.state.uploaded];
            const selected = [...this.state.selected];
            const uploading = [...this.state.uploading];
            if (error) {
              if (errored.indexOf(id) === -1) errored.push(id);
            } else {
              this.props.onNewImageSuccess(this.props.charger.pk, response);
              if (uploaded.indexOf(id) === -1) uploaded.push(id);
            }
            if (selected.indexOf(id) !== -1) selected.splice(selected.indexOf(id), 1);
            if (uploading.indexOf(id) !== -1) uploading.splice(uploading.indexOf(id), 1);
            this.setState({
              progress: Math.min(this.state.progress + (1 / images.length), 1),
            }, () => {
              this.setState({
                errored,
                uploaded,
                selected,
                uploading,
              });
            });
          });
        }
      });
    });
  }

  render() {
    const { handleClose, display } = this.props;
    const { files, filesById, uploaded, errored, selected, progress, uploading } = this.state;

    const progressStart = 0.02;
    const progressRebase = progressStart + (progress * (1 - progressStart));

    const isSubmitting = uploading.length > 0;

    return (
      <Modal
        id='upload-images'
        title='Upload Images'
        handleClose={handleClose}
        display={display}
      >

        <ModalBody>

          { files && filesById ?
            <div styleName='files-wrapper'>
              <ol styleName='files'>
                { files.map((id) => {
                  const file = filesById[id];
                  const classes = [];
                  if (selected.indexOf(id) !== -1) classes.push('selected');
                  if (uploaded.indexOf(id) !== -1) classes.push('uploaded has-success');
                  if (errored.indexOf(id) !== -1) classes.push('errored has-error');
                  return (
                    <li
                      key={id}
                      className={classes.join(' ')}
                      onClick={() => this.handleImageClick(id)}
                    >

                      <div styleName='image' style={{ backgroundImage: `url(${file.preview})` }} />

                    </li>
                  );
                }) }
              </ol>
            </div>
          : null }

          <Dropzone
            className='dropzone'
            activeClassName='active'
            onDrop={this.onDrop}
            accept='image/*'
          >
            <span>{ files.length > 0 ?
              'Add more images...'
              :
              'Add images by dragging-and-dropping them or clicking here.'
            }</span>
          </Dropzone>

          <ReactCSSTransitionGroup
            transitionName='progress'
            transitionEnterTimeout={300}
            transitionLeaveTimeout={900}
          >
            { isSubmitting ?
              <div styleName='progress'>
                <div
                  className='progress-bar progress-bar-striped active'
                  role='progressbar'
                  aria-valuenow={progressRebase * 100}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  style={{ width: `${progressRebase * 100}%` }}
                >
                  <span className='sr-only'>{ progressRebase * 100 }</span>
                </div>
              </div>
            : null }
          </ReactCSSTransitionGroup>

        </ModalBody>

        <ModalFooter
          submitButtonEnabled={files.length > 0 && files.length !== uploaded.length}
          isSubmitting={isSubmitting}
          submitButtonTitle={(
            this.state.selected.length > 0 ? `Upload ${selected.length} Selected` : 'Upload All'
          )}
          onSubmitClick={this.handleSubmit}
        />

      </Modal>
    );
  }
}

export default Upload;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Charger/components/Images/Upload.jsx